export const getState = (state) => state.data.memoAgreements

const getMemoAgreementList = (state) => getState(state).memoAgreementList
export const isMemoAgreementListLoading = (state) => getMemoAgreementList(state).isLoading
export const getMemoAgreementListData = (state) => getMemoAgreementList(state).data

const getActiveMemoAgreement = (state) => getState(state).memoAgreement
export const getActiveMemoAgreementData = (state) => getActiveMemoAgreement(state).data
export const isActiveMemoAgreementLoading = (state) => getActiveMemoAgreement(state).isLoading
